import * as autocomplete from "@angular/material/autocomplete";
import * as badge from "@angular/material/badge";
import * as bottomSheet from "@angular/material/bottom-sheet";
import * as button from "@angular/material/button";
import * as buttonToggle from "@angular/material/button-toggle";
import * as card from "@angular/material/card";
import * as checkbox from "@angular/material/checkbox";
import * as chips from "@angular/material/chips";
import * as core from "@angular/material/core";
import * as datepicker from "@angular/material/datepicker";
import * as dialog from "@angular/material/dialog";
import * as divider from "@angular/material/divider";
import * as expansion from "@angular/material/expansion";
import * as formField from "@angular/material/form-field";
import * as gridList from "@angular/material/grid-list";
import * as icon from "@angular/material/icon";
import * as input from "@angular/material/input";
import * as list from "@angular/material/list";
import * as menu from "@angular/material/menu";
import * as paginator from "@angular/material/paginator";
import * as progressBar from "@angular/material/progress-bar";
import * as progressSpinner from "@angular/material/progress-spinner";
import * as radio from "@angular/material/radio";
import * as select from "@angular/material/select";
import * as slider from "@angular/material/slider";
import * as slideToggle from "@angular/material/slide-toggle";
import * as snackBar from "@angular/material/snack-bar";
import * as sort from "@angular/material/sort";
import * as stepper from "@angular/material/stepper";
import * as table from "@angular/material/table";
import * as tabs from "@angular/material/tabs";
import * as toolbar from "@angular/material/toolbar";
import * as tooltip from "@angular/material/tooltip";
import * as tree from "@angular/material/tree";
import * as sidenav from "@angular/material/sidenav";

if (window["ng"] == null) window["ng"] = <any>{};

const material = {
  // TODO alles met ... moet weg als BARDOC/Basiscomponenten ook gebruik maken van sub folders in de imports, alhoewel het geen kwaad kan (by ref)
  ...autocomplete,
  ...badge,
  ...bottomSheet,
  ...button,
  ...buttonToggle,
  ...card,
  ...checkbox,
  ...chips,
  ...core,
  ...datepicker,
  ...dialog,
  ...divider,
  ...expansion,
  ...formField,
  ...gridList,
  ...icon,
  ...input,
  ...list,
  ...menu,
  ...paginator,
  ...progressBar,
  ...progressSpinner,
  ...radio,
  ...select,
  ...sidenav,
  ...slider,
  ...slideToggle,
  ...snackBar,
  ...sort,
  ...stepper,
  ...table,
  ...tabs,
  ...toolbar,
  ...tooltip,
  ...tree,
  autocomplete,
  badge,
  bottomSheet,
  button,
  buttonToggle,
  card,
  checkbox,
  chips,
  core,
  datepicker,
  dialog,
  divider,
  expansion,
  formField,
  gridList,
  icon,
  input,
  list,
  menu,
  paginator,
  progressBar,
  progressSpinner,
  radio,
  select,
  sidenav,
  slider,
  slideToggle,
  snackBar,
  sort,
  stepper,
  table,
  tabs,
  toolbar,
  tooltip,
  tree,
};

window["ng"].material = material;

import * as cdkA11y from "@angular/cdk/a11y";
import * as cdkAccordeon from "@angular/cdk/accordion";
import * as cdkBidi from "@angular/cdk/bidi";
import * as cdkCoercion from "@angular/cdk/coercion";
import * as cdkCollections from "@angular/cdk/collections";
import * as cdkKeycodes from "@angular/cdk/keycodes";
import * as cdkLayout from "@angular/cdk/layout";
import * as cdkObservers from "@angular/cdk/observers";
import * as cdkOverlay from "@angular/cdk/overlay";
import * as cdkPlatform from "@angular/cdk/platform";
import * as cdkPortal from "@angular/cdk/portal";
import * as cdkScrolling from "@angular/cdk/scrolling";
import * as cdkStepper from "@angular/cdk/stepper";
import * as cdkTable from "@angular/cdk/table";
import * as cdkTextField from "@angular/cdk/text-field";
import * as cdkTree from "@angular/cdk/tree";
import * as cdkDragDrop from "@angular/cdk/drag-drop";
import { Version } from "@angular/core";

const cdk = {
  a11y: cdkA11y,
  accordeon: cdkAccordeon,
  bidi: cdkBidi,
  coercion: cdkCoercion,
  collections: cdkCollections,
  keycodes: cdkKeycodes,
  layout: cdkLayout,
  observers: cdkObservers,
  overlay: cdkOverlay,
  platform: cdkPlatform,
  portal: cdkPortal,
  scrolling: cdkScrolling,
  stepper: cdkStepper,
  table: cdkTable,
  textField: cdkTextField,
  tree: cdkTree,
  dragDrop: cdkDragDrop,
  // NOTE inject version because at runtime depending on the app the material bundle will check if the version is the same as the CDK version
  VERSION: new Version(process.env.VERSION),
};

window["ng"].cdk = cdk;

export { material, cdk };
